'use strict';

import { forEach } from 'lodash';

import { subscribe } from '../../01-helpers/event-manager';
import { getDateAsString } from '../../01-helpers/utilities/date';

import { PILL_REMOVED } from '../../02-const/event-names';

import FilterInput from '../../04-components/filtering/filter-input';

const moduleName = 'filter-date',
	selectors = {
		base: `.js-${moduleName}`
	},
	attributeNames = {
		dataRefresh: 'data-refresh'
	};

export default class FilterDate extends FilterInput {

	constructor(baseElement) {
		super(baseElement);
		this.input = this.baseElement.querySelector('input');

		this._subscribeEvents();
	}

	_updateDates(startValue, endValue, type) {
		if (type === type.START) {
			let newDate = new Date(startValue);
			newDate.setDate(newDate.getDate() + 1);
			this.endDate.value = getDateAsString(newDate);
		} else {
			let newDate = new Date(endValue);
			newDate.setDate(newDate.getDate() - 1);
			this.startDate.value = getDateAsString(newDate);
		}
	}

	/**
	 *
	 *
	 **/
	_clearDate(event) {
		const filterId = event?.detail?.id,
			refresh = this.input.getAttribute(attributeNames.dataRefresh);

		if (filterId === undefined || this.input.id != filterId) {
			return false;
		}

		let tFilters = this.filterContext.state.Filters,
			found = false;

		tFilters.find((item, index) => {
			// if filter is alreay found/removed, we can return;
			if (found) {
				return;
			}
			if (item.Id === filterId) {
				tFilters.splice(index, 1);
				found = true;
			}
		});

		this.filterContext.update(
			{
				NodeId: this.NodeId,
				Page: this.Page,
				Filters: tFilters
			},
			{ refresh: refresh === 'true' }
		);
		this._setPush('filter_remove', this.key, 'remove', 'Remove', `${this.input.name}|${this.key}`);

		this.input.valueAsDate = null;
	}

	_updateFilterContext(element) {
		const value = element.value,
			id = element.id;

		let tFilters = this.filterContext.state.Filters;

		const result = tFilters.filter((v) => {
			return v.Id === id;
		});

		if (result.length) {
			let found = false;
			tFilters.find((item, index) => {
				// if filter is alreay found/removed, we can return;
				if (found) {
					return;
				}
				if (item.Id === id) {
					item.Value = value;
					found = true;
				}
			});
		} else {
			tFilters.push(
				{
					Type: this.key,
					Value: value,
					Id: id,
					Name: element.name,
					Format: 'yyyy-MM-dd'
				}
			);
		}
		return tFilters;
	}

	_subscribeEvents() {
		subscribe(PILL_REMOVED, (event) => this._clearDate(event));
	}
}

/* ========================================================================== */

const initFilterDate = () => {
	forEach(document.querySelectorAll(selectors.base), (selectionElement) => {
		new FilterDate(selectionElement);
	});
};

initFilterDate();